import React, { useState } from 'react';
import './modalLibro.css';
import iconoCompartir from "../../assets/imgs/detalle_blog/share-white.svg";
import iconoX from "../../assets/imgs/detalle_blog/logo-x.svg";
import iconoFacebook from "../../assets/imgs/detalle_blog/Asset_Facebook-normal.svg";
import iconoLinkedIn from "../../assets/imgs/detalle_blog/LinkedIn.svg";
import iconoMail from "../../assets/imgs/detalle_blog/Asset_Mail-Normalblanco.svg";
import iconoCopiar from "../../assets/imgs/detalle_blog/Link.svg";

const ifButton = (blog_gruid, idioma, titulo) => {

  if (blog_gruid !== null) {

    return <div class="buton_bp2_div"><a class="buton_bp2 espac" href={'https://www.ricardosalinas.com/blog/' + blog_gruid + '?lang=' + idioma}>Blog </a></div>;

  } else {
    if (titulo == 'Cómo pensar la economía' || titulo == 'How to Think About the Economy: A Primer') {
      console.log("Entro al libro");
      var blogtext2 = idioma == "es" ? "Descarga" : "Download";
      return <div class="buton_bp2_div"><a target="_blank" class="buton_bp2 espac" href={'https://play.google.com/store/books/details?id=Cdq-EAAAQBAJ&pli=1'}>{blogtext2} </a></div>;

    }
    else {
      return "";
    }

  }

};



const ModalLibro = ({ isOpen, closeModal, variable1, variable2, variable3, variable4, variable5, variable6, variable7, variable8, variable9, id_idea }) => {
  if (!isOpen) return null;

  const handleX = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        "https://www.ricardosalinas.com/es/biblioteca?libro="+id_idea
      )}&text=${encodeURIComponent("Mira este libro que recomienda Ricardo Salinas")}`,
      "_blank"
    );
  };
  
  const handleFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("https://www.ricardosalinas.com/es/biblioteca?libro="+id_idea)}`,
      "_blank"
    );
  };
  
  const handleLinkedIn = (e) => {
    window.open(
      `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
        "https://www.ricardosalinas.com/es/biblioteca?libro="+id_idea
      )}&title=${encodeURIComponent("Mira este libro que recomienda Ricardo Salinas")}`,
      "_blank"
    );
  };
  
  const handleMail = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(
      ""
    )}&body=${encodeURIComponent("https://www.ricardosalinas.com/es/biblioteca?libro="+id_idea)}`;
  };
  
  const handleCopiarURL = () => {
    navigator.clipboard.writeText("https://www.ricardosalinas.com/es/biblioteca?libro="+id_idea).then(() => {
      alert('¡Enlace copiado al portapapeles!');
    }).catch((error) => {
      console.error('Error al copiar al portapapeles:', error);
    });
  };

  return (

    <div className="modal_Lib">
      <div className="modalContent_Lib">

        {/* <div dangerouslySetInnerHTML={{__html:variable1}}>
        </div> */}


        <div className='row'>
          <div className='colum1_Libr_modal'>
            {/* <img class="imgG_bp" src={variable1} +{variable2} alt={"ejemplo"} /> */}
            <img className="imgG_modalLibro" src={variable1} alt={variable2} />


          </div>
          <div className='colum2_Libr_modal'>
            <div className='row_modal'>
              <h3 className='modal-title' > {variable3}</h3>
              <hr />
              <p className='card-text'> {variable4}</p>
              {/* <p> {variable5}</p>
            <p> {variable6}</p>
            <p> {variable7}</p> */}
            </div>
            <div className='row_modal2'>
              <div className='colum2_Libr_modal'>
                <p className='datosLibr'> {variable5}</p>
                <p className='datosLibr'> {variable6}</p>
                <p className='datosLibr'> {variable7}</p>
                {/* <p>oy varia 8 +{variable8}</p> */}
                {/* <p> soy varia 9 +{variable9}</p> */}
              </div>

              {/* if({variable8}!=null ){ */}


              {ifButton(variable8, variable9, variable3)}



              {
                // if(variable8!=null){
                // 'https://www.ricardosalinas.com/blog/es/c224c4fb-a8f4-4e92-af14-02b98741c594'
                // <a class="buton_bp" target="_blank" href="#">blog</a>



              }


              {/* <div className='colum2_Libr_modal'> */}


              {/* </div> */}
            </div>
          </div>
        </div>

        {/* <p>Variable 2: {variable2}</p> */}
        <button className="botonPop_Lib tache" onClick={closeModal}><span aria-hidden="true">×</span></button>
        <div className="barra_texto_Desk_div barra_texto_Desk_div_carrusel">
              <div className="barra_texto_Desk">
                <button>
                  <div className="container-imagen">
                    <img src={iconoCompartir} alt="icono compartir" />
                  </div>
                  <ul className="socials" onClick={(e) => e.stopPropagation()}>
                    <li>
                      <img src={iconoX} alt="icono x" onClick={handleX} />
                    </li>
                    <li>
                      <img
                        src={iconoFacebook}
                        alt="icono facebook"
                        onClick={handleFacebook}
                      />
                    </li>
                    <li>
                      <img
                        src={iconoLinkedIn}
                        alt="icono linkedIn"
                        onClick={handleLinkedIn}
                      />
                    </li>
                    <li>
                      <img src={iconoMail} alt="icono mail" onClick={handleMail} />
                    </li>
                    <li>
                      <img
                        src={iconoCopiar}
                        alt="icono copiar url"
                        onClick={handleCopiarURL}
                      />
                    </li>
                  </ul>
                </button>
              </div>
            </div>
      </div >
      <div className="background_gri_Lib"></div>
    </div >
  );
};

export default ModalLibro;